import { pipe } from 'ramda';
import { inlineEditorHtml, stripHtmlString } from '../../../../../../../app/common/helpers/browser';
import { formatNumber } from '../../../../../../../app/common/money';
export var formatHtml = pipe(inlineEditorHtml, stripHtmlString);
export var pluralize = function (count, itemName) {
    return "".concat(formatNumber(count, 0), " ").concat(itemName).concat(count === 1 ? '' : 's');
};
